import api from "../../api/api";

export const produtosService = {
  getAll: async () => {
    const res = await api.get("/produtos");
    return res.data;
  },

  create: async (data) => {
    const res = await api.post("/produtos", data);
    return res.data;
  },

  update: async (id, data) => {
    const res = await api.put(`/produtos/${id}`, data);
    return res.data;
  },

  activate: async (id) => {
    const res = await api.put(`/produtos/${id}/ativar`);
    return res.data;
  },

  deactivate: async (id) => {
    const res = await api.put(`/produtos/${id}/desativar`);
    return res.data;
  },

  // ── Imagem ────────────────────────────────────────────────────────────────

  uploadImagem: async (id, file) => {
    const form = new FormData();
    form.append("imagem", file);
    const res = await api.post(`/produtos/${id}/imagem`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data; // { imagem_url, produto }
  },

  removerImagem: async (id) => {
    const res = await api.delete(`/produtos/${id}/imagem`);
    return res.data;
  },
};